<template>
    <a @click="removeFavoriteItem" class="remove-wishlist" href="javascript:;">
        <i class="demo-icon icon-union-50"></i>
        {{title}}
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "favorite-list-delete-item",

        components: {
        },

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {object} favoriteData - Информауия товарах в корзине
         */


        props: [
            'product_id', 'title'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string|int} productId - Id товара за который отвечает компонент
         */
        data() {
            return {
                productId : this.product_id,
            }
        },

        mounted(){
        },

        methods: {
            removeFavoriteItem(){
                this.$store.dispatch('favorite/removeFavoriteItem',this.productId);
            },
        }
    }


</script>
